import { SVGProps } from 'react';

function BorderHorizontal(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-border-horizontal"
            {...props}
        >
            <path
                fill="currentColor"
                stroke="none"
                d="M1 1h1.5v1.5H1V1zm0 4h1.5v1.5H1V5zm0 4.15h18v1.2H1V9.15zm0 3.85h1.5v1.5H1v-1.5zm0 4h1.5v1.5H1v-1.5zM5 1h1.5v1.5H5V1zm0 16h1.5v1.5H5v-1.5zM9 1h1.5v1.5H9V1zm0 4h1.5v1.5H9V5zm0 8h1.5v1.5H9v-1.5zm0 4h1.5v1.5H9v-1.5zm4-16h1.5v1.5h-1.5V1zm0 16h1.5v1.5h-1.5v-1.5zm4-16h1.5v1.5h-1.5V1zm0 4h1.5v1.5h-1.5V5zm0 8h1.5v1.5h-1.5v-1.5zm0 4h1.5v1.5h-1.5v-1.5z"
            />
        </svg>
    );
}

export default BorderHorizontal;
